module.exports = __webpack_public_path__ + "static/media/help.cafb8efe.svg";